class EnrichPawsProduct extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form[action*="/cart/add"]');
    this.variantInput = this.querySelector('input[name="id"]');
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.currentVariant = this.variants.find((variant) => String(variant.id) === String(this.variantInput?.value)) || this.variants[0];
    this.updateOffer(this.currentVariant);
    this.startOfferCountdown();
    this.setupReviewSync();

    this.querySelectorAll('[data-option]').forEach((input) => {
      input.addEventListener('change', () => this.selectVariant());
    });

    this.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = this.querySelector('[data-quantity]');
        const change = Number(button.dataset.quantityChange);
        input.value = Math.max(1, Number(input.value || 1) + change);
      });
    });

    this.querySelectorAll('[data-media-id]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = this.querySelector(`[data-main-media="${button.dataset.mediaId}"]`);
        if (!target) return;
        this.querySelectorAll('[data-main-media]').forEach((media) => { media.hidden = true; });
        this.querySelectorAll('[data-media-id]').forEach((thumb) => thumb.setAttribute('aria-current', 'false'));
        target.hidden = false;
        button.setAttribute('aria-current', 'true');
      });
    });

    this.querySelectorAll('[data-sticky-add]').forEach((button) => {
      button.addEventListener('click', () => this.form?.querySelector('[type="submit"]')?.click());
    });

    this.querySelectorAll('[data-sticky-buy-now]').forEach((button) => {
      button.addEventListener('click', async () => {
        const submit = this.form?.querySelector('[type="submit"]');
        if (!this.form || button.disabled || submit?.disabled) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form)
          });
          if (!response.ok) throw new Error('Unable to add the selected item to checkout.');
          window.location.assign(`${root}checkout`);
        } catch (error) {
          console.error(error);
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    });

    this.querySelector('[data-scroll-reviews]')?.addEventListener('click', (event) => {
      event.preventDefault();
      const reviews = document.querySelector(
        '#judgeme_product_reviews, .jdgm-rev-widg, #shopify-product-reviews, .spr-reviews'
      );
      if (!reviews) return;
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (!reviews.hasAttribute('tabindex')) reviews.setAttribute('tabindex', '-1');
      reviews.focus({ preventScroll: true });
    });
  }

  selectVariant() {
    const selected = [...this.querySelectorAll('[data-option]:checked')].map((input) => input.value);
    const variant = this.variants.find((item) => item.options.every((option, index) => option === selected[index]));
    if (!variant) return;

    this.variantInput.value = variant.id;
    const submit = this.form.querySelector('[type="submit"]');
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? submit.dataset.addLabel : submit.dataset.soldLabel;

    this.querySelectorAll('[data-product-price]').forEach((price) => {
      price.textContent = this.formatMoney(variant.price);
    });
    const compare = this.querySelector('[data-compare-price]');
    if (compare) {
      compare.textContent = variant.compare_at_price ? this.formatMoney(variant.compare_at_price) : '';
      compare.hidden = !variant.compare_at_price;
    }
    this.currentVariant = variant;
    this.updateOffer(variant);
    history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  }

  updateOffer(variant) {
    const offer = this.querySelector('[data-ep-offer]');
    if (!offer || !variant) return;
    const compare = Number(variant.compare_at_price || 0);
    const price = Number(variant.price || 0);
    const onSale = compare > price;
    const saving = Math.max(0, compare - price);
    offer.hidden = !onSale;
    offer.querySelector('[data-offer-saving]').textContent = this.formatMoney(saving);
    offer.querySelector('[data-offer-percent]').textContent = onSale ? Math.round(saving / compare * 100) : 0;
  }

  startOfferCountdown() {
    const offer = this.querySelector('[data-ep-offer]');
    if (!offer) return;
    let deadline = Date.parse(offer.dataset.deadline || '');
    if (!Number.isFinite(deadline) || deadline <= Date.now()) {
      const key = `ep-product-offer-${location.pathname}`;
      deadline = Number(sessionStorage.getItem(key));
      if (!deadline || deadline <= Date.now()) {
        deadline = Date.now() + Number(offer.dataset.evergreenHours || 24) * 3600000;
        sessionStorage.setItem(key, String(deadline));
      }
    }
    const tick = () => {
      const seconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      offer.querySelector('[data-offer-hours]').textContent = String(Math.floor(seconds / 3600)).padStart(2, '0');
      offer.querySelector('[data-offer-minutes]').textContent = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
      offer.querySelector('[data-offer-seconds]').textContent = String(seconds % 60).padStart(2, '0');
    };
    tick();
    this.offerTimer = window.setInterval(tick, 1000);
  }

  setupReviewSync() {
    const ratingButton = this.querySelector('[data-scroll-reviews]');
    if (!ratingButton) return;

    const connectWidget = () => {
      const widget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
      if (!widget) return false;

      const syncRating = () => {
        const ratingParts = [...widget.querySelectorAll('.jm-average-rating-display .jm-text')]
          .map((element) => element.textContent.trim())
          .filter(Boolean);
        const visibleRating = ratingParts.find((text) => /^\d+(?:[.,]\d+)?$/.test(text));
        const visibleCount = ratingParts.find((text) => text !== visibleRating && /\d+/.test(text));
        const rating = Number.parseFloat((visibleRating || widget.dataset.shopAverageRating || '0').replace(',', '.'));
        const countMatch = (visibleCount || widget.dataset.shopReviewCount || '0').match(/\d+/);
        const count = Number.parseInt(countMatch?.[0] || '0', 10);
        if (!Number.isFinite(rating) || !Number.isFinite(count)) return;

        const [stars, summary] = ratingButton.querySelectorAll('span');
        const language = document.documentElement.lang || 'en';
        if (stars) {
          stars.setAttribute(
            'aria-label',
            language.startsWith('he') ? `${rating.toFixed(1)} מתוך 5 כוכבים` : `${rating.toFixed(1)} out of 5 stars`
          );
        }
        if (summary) {
          if (count === 0) {
            summary.textContent = language.startsWith('he') ? 'עדיין אין ביקורות' : 'No reviews yet';
          } else {
            summary.textContent = language.startsWith('he')
              ? `${rating.toFixed(1)} · ${count} ביקורות לקוחות`
              : `${rating.toFixed(1)} · ${count} customer ${count === 1 ? 'review' : 'reviews'}`;
          }
        }
      };

      this.reviewObserver?.disconnect();
      this.reviewObserver = new MutationObserver(syncRating);
      this.reviewObserver.observe(widget, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
        attributeFilter: ['data-shop-average-rating', 'data-shop-review-count']
      });
      syncRating();
      return true;
    };

    if (connectWidget()) return;
    this.reviewWaitObserver = new MutationObserver(() => {
      if (!connectWidget()) return;
      this.reviewWaitObserver.disconnect();
      this.reviewWaitObserver = null;
    });
    this.reviewWaitObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    if (this.offerTimer) window.clearInterval(this.offerTimer);
    this.reviewObserver?.disconnect();
    this.reviewWaitObserver?.disconnect();
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: this.dataset.currency
    }).format(cents / 100);
  }
}

if (!customElements.get('enrichpaws-product')) {
  customElements.define('enrichpaws-product', EnrichPawsProduct);
}
